import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
    wrapper: {
        marginBottom: '20px',
        width: '100%',
        '& .MuiSelect-icon': {
            top: 'calc(50% - 2px)',
            right: '25px',
        },
    },
    selectMenu: {
        width: '100%',
        '& .MuiFocused, & > div': {
            backgroundColor: '#fff',
            borderTopLeftLadius: 0,
            borderTopRightRadius: 0,
        },
        '& .MuiSelect-icon': {
            top: 'calc(50% - 2px)',
            right: '25px',
        },
    },
    selectMenuContent: {
        boxSizing: 'border-box',
        height: 'auto',
        fontSize: theme.typography.pxToRem(20),
        color: theme.palette.primary.light,
        fontWeight: 400,
        padding: '20px 35px 6px',
        '&:focus': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
        },
    },
    selectMenuItems: {
        '& ul li': {
            fontSize: theme.typography.pxToRem(18),
            color: theme.palette.primary.light,
            fontWeight: 300,
        },
    },
    icon: {
        fill: 'none',
        stroke: '#53759B',
        strokeWidth: '2px',
    },
    errorIcon: {
        fill: 'none',
        stroke: theme.palette.error.main,
        strokeWidth: '2px',
    },
}));
